import Vue from 'vue';
import Vuex from 'vuex';
import cart from './modules/cart';
import courseRegistration from './modules/courseRegistration';
import auth from './modules/auth';
import messages from './modules/messages';
import navigation from './modules/navigation';
import createPersistedState from "vuex-persistedstate";


// import * as actions from './actions';

Vue.use(Vuex);


export default new Vuex.Store({
	// actions,
	modules: {
		auth,
		cart,
		messages,
		navigation,
		courseRegistration
	},
	plugins: [createPersistedState({
		paths: ['navigation', 'auth', 'cart', 'courseRegistration'],
	})]
});